var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"email","d":"M15.24,2.54a12.7,12.7,0,1,1-12.7,12.7A12.7,12.7,0,0,1,15.24,2.54Zm0-2.54A15.24,15.24,0,1,0,30.48,15.24,15.24,15.24,0,0,0,15.24,0Zm8.2,13.86V11.28a2,2,0,0,0-1.9-2c-.39,0-.78,0-1.15,0H9a2,2,0,0,0-2,2h0v7.9a2,2,0,0,0,2,2H21.39a2,2,0,0,0,2.05-1.95V13.86Zm-5.08,1.38L22,12.65v5.18Zm-6.24,0-3.67,2.6V12.65Zm4.4-.43c-.1.08-.21.14-.31.21l-.15.1a1.4,1.4,0,0,1-.93.21,1.66,1.66,0,0,1-.87-.31L13,14.13l-1.8-1.25L9.53,11.72l-1-.72A.61.61,0,0,1,9,10.69H21.4A.61.61,0,0,1,22,11ZM10.4,18.18l3-2.1,0,0a2.94,2.94,0,0,0,.71.4,3,3,0,0,0,2.43-.07,3.32,3.32,0,0,0,.53-.33l0,0,4.28,3a2.48,2.48,0,0,1,.26.19l.09.06.21.15a.59.59,0,0,1-.51.3H9.05a.61.61,0,0,1-.52-.31Z"}));
}

Mail.defaultProps = {"viewBox":"0 0 30.48 30.48"};

module.exports = Mail;

Mail.default = Mail;
